import axios from "axios";

export let baseUrl = "https://sirldigital.com/residentJob/api";
// export let baseUrl = "https://0g01d8wd-4000.inc1.devtunnels.ms/api";
// export let baseUrl = "https://1qsx0vd0-4000.inc1.devtunnels.ms/api";
// export let baseUrl = "http://192.168.100.69:5000/api";

const api = async (path, params, method) => {
  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
